<template>
  <el-popover
    ref="popoverDatesSelect"
    placement="bottom-start"
    width="350"
    trigger="click"
  >
    <template name="—">
      <p class="pb-2 d-inline-block m-0 font-bold text-color-blank">
        Buscar por fechas
      </p>
      <i
        class="el-icon-circle-close float-right cursor-point"
        @click="closePopoverDates"
      ></i>
      <el-radio
        v-for="(date, index) in filterDates"
        :key="index"
        v-model="rangeDates"
        :label="date.label"
        class="d-block my-2"
        >{{ date.title }}</el-radio
      >
      <el-date-picker
        v-model="customRangedates"
        @change="handleChangeCustomRangedates"
        format="dd-MM-yyyy"
        value-format="yyyy-MM-dd"
        type="daterange"
        v-if="rangeDates === 'dateRages'"
      ></el-date-picker>
    </template>
    <el-input
      slot="reference"
      :value="selectDate"
      placeholder="Filtrar por fechas"
      suffix-icon="el-icon-date"
      class="cursor-point"
      :class="{ 'has-value': !!selectDate }"
      readonly
    >
    </el-input>
  </el-popover>
</template>

<script>
import moment from "moment";
import { filterDates } from "@/services/DateServices";
export default {
  name: "FilterBetweenDatesSelect",
  data() {
    return {
      rangeDates: null,
      searchDates: null,
      customRangedates: null,
      selectDate: null,
      filterDates
    };
  },
  computed: {
    placeholder() {
      return this.selectDate || "Filtrar por fechas";
    }
  },
  watch: {
    keyRangeDates(value) {
      this.rangeDates = value;
    },
    rangeDates() {
      if (!this._mounting) {
        this.handleChangeRageDates();
      }
    }
  },
  methods: {
    closePopoverDates() {
      this.$refs.popoverDatesSelect.doClose();
    },
    handleChangeRageDates() {
      this.searchDates = null;
      this.selectDate = null;

      // Compute dates live so they are always accurate regardless of when
      // the module was first imported (stale module-level constants fix).
      const today = moment().format("YYYY-MM-DD");

      switch (this.rangeDates) {
        case "currentDay":
          this.selectDate = "Hoy";
          this.searchDates = { from: today, to: today };
          break;
        case "lastWeek":
          this.selectDate = "Última semana";
          this.searchDates = {
            from: moment()
              .subtract(7, "days")
              .startOf("week")
              .format("YYYY-MM-DD"),
            to: today
          };
          break;
        case "currentMonth":
          this.selectDate = "Mes actual";
          this.searchDates = {
            from: moment()
              .startOf("month")
              .format("YYYY-MM-DD"),
            to: moment()
              .endOf("month")
              .format("YYYY-MM-DD")
          };
          break;
        case "lastMonth":
          this.selectDate = "Mes anterior";
          this.searchDates = {
            from: moment()
              .subtract(1, "months")
              .startOf("month")
              .format("YYYY-MM-DD"),
            to: moment()
              .subtract(1, "months")
              .endOf("month")
              .format("YYYY-MM-DD")
          };
          break;
        case "currentYear":
          this.selectDate = "Último año";
          this.searchDates = {
            from: moment()
              .startOf("year")
              .format("YYYY-MM-DD"),
            to: moment()
              .endOf("year")
              .format("YYYY-MM-DD")
          };
          break;
        case "lastYear":
          this.selectDate = "Año anterior";
          this.searchDates = {
            from: moment()
              .subtract(1, "years")
              .startOf("year")
              .format("YYYY-MM-DD"),
            to: moment()
              .subtract(1, "years")
              .endOf("year")
              .format("YYYY-MM-DD")
          };
          break;
        case "dateRages":
          this.selectDate = "Rango de fechas";
          break;
        default:
          break;
      }
      if (this.rangeDates !== "dateRages") this.onAsyncDataForDates();
    },
    onAsyncDataForDates() {
      this.$emit("onAsyncDataForDates", {
        searchDates: {
          ...this.searchDates,
          ...{
            keyRangeDates: this.rangeDates
          }
        }
      });
      this.closePopoverDates();
    },
    handleChangeCustomRangedates() {
      this.searchDates = null;
      if (this.customRangedates)
        this.searchDates = {
          from: this.customRangedates[0],
          to: this.customRangedates[1]
        };
      this.onAsyncDataForDates();
    }
  },
  mounted() {
    this._mounting = true;
    if (this.keyRangeDates) {
      // Restaurar selección previa desde la prop
      this.rangeDates = this.keyRangeDates;
    } else if (typeof this.defaultMonthValue != "object") {
      this.rangeDates = "currentMonth";
    }
    if (this.rangeDates) {
      this.handleChangeRageDates();
    }
    this.$nextTick(() => {
      this._mounting = false;
    });
  },
  props: {
    keyRangeDates: {
      default: null,
      type: String
    },
    defaultMonthValue: {
      default: null,
      type: Boolean
    }
  }
};
</script>

<style lang="scss" scoped>
.el-range-editor {
  width: 100% !important;
}
.has-value {
  ::v-deep .el-input__inner {
    color: #2d2b55;
    font-weight: 500;
  }
}
</style>
